"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLQATasksBulkSelectionPanel = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const hlqa_tasks_bulk_selection_panel_styles_1 = require("./hlqa-tasks-bulk-selection-panel.styles");
const localization_1 = require("../../../../../localization");
const HLQATasksBulkSelectionPanel = ({ totalCount, selectedItemsCount, areAllTasksSelected, onSelectAllTasks, onResetSelectedTasks, onEdit, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(hlqa_tasks_bulk_selection_panel_styles_1.StyledHLQATasksBulkSelectionPanel, null, react_1.default.createElement(ui_components_1.Typography, { color: "textSecondary", variant: "body2" }, t({
        key: 'ITEMS_SELECTED',
        values: {
            count: areAllTasksSelected ? totalCount : selectedItemsCount,
            item: t({ key: 'TASK' }),
        },
    })), react_1.default.createElement(hlqa_tasks_bulk_selection_panel_styles_1.StyledSelectAllButton, { rounded: true, color: "primary", variant: "text", onClick: areAllTasksSelected ? onResetSelectedTasks : onSelectAllTasks }, areAllTasksSelected
        ? t({ key: 'DESELECT_ALL' })
        : t({ key: 'SELECT_ALL_N_ITEMS', values: { count: totalCount } })), react_1.default.createElement(ui_components_1.Button, { rounded: true, variant: "outlined", title: t({ key: 'EDIT' }), onClick: onEdit })));
};
exports.HLQATasksBulkSelectionPanel = HLQATasksBulkSelectionPanel;
